export function tnNoauto() {
    return {
        restrict: 'A', // update only attributes
        link(scope, element) {
            element.attr({
                autocomplete: 'off',
                autocorrect: 'off',
                autocapitalize: 'off',
                spellcheck: 'false',
            });
        },
    };
}
